import { useEffect, useState } from 'react'

// Note: might be nice to move this list to a database to make it easy to update
const options = [
  'Asian Pacific Americans',
  'Black Employee Network',
  'Indigenous',
  'MyAbilities',
  'OUT',
  'Unidos',
  'Veterans Network',
  'Womens Network',
  'Young Professionals Network',
]
const csvToSet = (s) => new Set(
  (!s) ? [] : s.split(',').map(x => x.trim()).filter(x => x !== '')
)
const setToCsv = (s) => [...s].sort((a, b) => a.localeCompare(b)).join(',')

const ERGFormGroup = (props) => {
  const { id, name, value, onChange } = props
  const addlProps = { ...props, id: undefined, value: undefined, onChange: undefined }
  const [selected, setSelected] = useState(() => csvToSet(value))
  useEffect(() => setSelected(csvToSet(value)), [value])

  const toggle = (label) => {
    setSelected((prev) => {
      const next = new Set(prev)
      if (next.has(label)) {
        next.delete(label)
      } else {
        next.add(label)
      }
      if (onChange) {
        onChange({
          target: {
            ...props,
            value: setToCsv(next),
          },
        })
      }
      return next
    })
  }

  return (
    <div>
      <p>If any, which Comcast Employee Resource Groups (ERGs) have you been involved with?</p>
      <div style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: '0.5rem',
        marginTop: '0.5rem',
      }}>
        {options.map((label) => {
          const isSelected = selected.has(label)
          return (
            <button
              key={label}
              type="button"
              onClick={() => toggle(label)}
              style={{
                padding: '0.35rem 0.85rem',
                borderRadius: '2rem',
                border: isSelected ? '2px solid var(--color-primary)' : '1px solid var(--color-border)',
                backgroundColor: isSelected ? 'var(--color-primary)' : 'var(--color-surface)',
                // Fixed white text on the saturated primary background.
                color: isSelected ? '#fff' : 'var(--color-text)',
                fontSize: '0.88rem',
                fontWeight: isSelected ? 600 : 400,
                cursor: 'pointer',
                transition: 'all 0.15s ease',
              }}
            >
              {isSelected && '✓ '}{label}
            </button>
          )
        })}
      </div>
    </div>
  )
}
export default ERGFormGroup